import { FeedSortType } from '@ai-platform/utils';

import { FeedSchema } from './types';

/**
 * Начальное состояние слайса ленты
 */
export const FEED_INITIAL_STATE: FeedSchema = {
    category: null,
    pageSize: 30,
    sort: FeedSortType.All,
};
